<c-container class="mt-5">
  <h2>Email Confirmations</h2>
  @if (uiState === uiStateEnumForTemplate.ShowData)
  {
  <form [formGroup]="filterForm">
    <div class="flex-row-wrap justify-space-between">
      <mat-form-field class="flex-50" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email Address" formControlName="email" data-testid="email-input">
        <mat-error *ngIf="emailControl.errors && (emailControl.dirty || emailControl.touched)">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex-50" appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type" data-testid="type-select">
          <mat-option [value]="null" data-testid="type-option">All</mat-option>
          @for (type of confirmationTypes; track type.value) {
            <mat-option [value]="type.value" data-testid="type-option">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-50" appearance="outline">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input
          [rangePicker]="picker">
          <input matStartDate placeholder="From" formControlName="fromDate" data-testid="from-date-input">
          <input matEndDate placeholder="To" formControlName="toDate" data-testid="to-date-input">
        </mat-date-range-input>
        <mat-hint>MM-DD-YYYY – MM-DD-YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field class="flex-50" appearance="outline">
        <mat-label>Confirmed</mat-label>
        <mat-select formControlName="confirmed" data-testid="confirmed-select">
          <mat-option [value]="null" data-testid="confirmed-option">All</mat-option>
          <mat-option [value]="true" data-testid="confirmed-option">Confirmed</mat-option>
          <mat-option [value]="false" data-testid="confirmed-option">Not Confirmed</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="text-end margin-bottom-med">
        <button matTooltip="Search emails"
                data-testid="search-emails-button"
                [disabled]="!filterForm.valid"
                mat-raised-button
                type="submit"
                color="primary"
                class="margin-right-small"
                (click)="onFormSubmit()">Search Emails
          <mat-icon>search</mat-icon>
        </button>
        <button matTooltip="reset filters"
                data-testid="reset-filter-button"
                mat-raised-button
                color="warn"
                (click)="onResetClick()">Reset Parameters
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
  </form>

  <ag-grid-angular
    class="ag-theme-quartz margin-top-med"
    data-testid="email-confirmation-table"
    [tooltipShowDelay]="0"
    [pagination]="true"
    [domLayout]="'autoHeight'"
    [suppressPaginationPanel]="true"
    overlayNoRowsTemplate="<span>No Email Confirmations</span>"
    (gridReady)="onGridReady($event)"
    [rowData]="emailConfirmations$ | async"
    [columnDefs]="colDefs">
  </ag-grid-angular>

  <div class="custom-paginator">
    <span>{{ fromNumber }}</span> to <span>{{ toNumber }}</span> of <span
    class="margin-right-large">{{ totalRecords }}</span>
    <mat-icon (click)="onBtFirst()" [ngClass]="pageNumber === 1 ? 'disabled' : ''">first_page</mat-icon>
    <mat-icon (click)="onBtPrevious()" [ngClass]="pageNumber === 1 ? 'disabled' : ''">navigate_before</mat-icon>
    Page <span>{{ pageNumber }}</span> of <span>{{ totalPages }}</span>
    <mat-icon (click)="onBtNext()"
              [ngClass]="pageNumber === pagedEmailConfirmationResponse?.TotalPages ? 'disabled' : ''">
      navigate_next
    </mat-icon>
    <mat-icon (click)="onBtLast()"
              [ngClass]="pageNumber === pagedEmailConfirmationResponse?.TotalPages ? 'disabled' : ''">
      last_page
    </mat-icon>
  </div>
  }
</c-container>
